import { } from './action';

function* resultSaga() {
}

export default resultSaga